export default "__VITE_ASSET__CHEGb_0c__"